import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-responsive-modal';
import { ThemeProvider } from 'styled-components';
import { compose } from 'recompose';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import StyledIcon from '../../../../../../../../styledComponents/styles/Icon.styled';

import { themeViaForms } from '../../../../../../../../styledComponents/settings/theme';
import { AccentButtonMediumNunito } from '../../../../../../../../styledComponents/styles/Buttons.styled';
import { AccentButtonSpinner } from '../../../../../../../../styledComponents/styles/spinner.styled';
import { ButtonMediumNunito } from '../../../../../../../../styledComponents/styles/Buttons.styled';
import TextInputArea from '../../../../../../../../styledComponents/styles/TextInputArea.styled';
// import { toast } from 'react-toastify';
// import toastMessageStyles from '../../../../../../../viaGlobal/components/toastMessage/toastMessage.scss';

import style from './style.scss';

export const enhance = compose(withStyles(style));

const ImageDescModal = props => {
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [altText, setAltText] = useState(props.selectedFile?.alt_text || '');
  const handleAltTextChange = e => {
    setAltText(e.target.value);
  };

  const handleSave = () => {
    if (props.selectedFile) {
      props.onSave({
        ...props.selectedFile,
        alt_text: altText,
      });
    }
    props.onClose(false);
  };

  return (
    <ThemeProvider theme={themeViaForms}>
      <div className={style.flexContainer}>
        <Modal
          blockScroll={false}
          open={props.show}
          onClose={() => props.onClose(false)}
          center
          styles={{
            overlay: { background: 'rgba(0, 0, 0, 0.65)' },
            modal: {
              maxWidth: '25%',
              width: !!props.width ? props.width : '25%',
              borderRadius: '5px',
              padding: '0px',
            },
            closeButton: {
              marginTop: '5.8px',
              marginRight: '20.8px',
              width: '24px',
              height: '24px',
            },
          }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
          showCloseIcon={false}
          closeIcon={<StyledIcon type="Close" color="#9FABAE" size="24px" />}
        >
          <div>
            <div className={style.header}>
              <span className={style.headerTitle}>Add Alt Text</span>
              <a className={style.closeIcon} onClick={() => props.onClose(false)}>
                <StyledIcon type="Close" color="#373737" size="24px" />
              </a>
            </div>
            <div className={style.childContainer}>
              <div className={style.content}>
                <div className={style.imageContainer}>
                  <img src={props.selectedFile?.s3_store} />
                  <div className={style.fileName}>{props.selectedFile?.file_name}</div>
                </div>
                <div className={style.inputContainer}>
                  <TextInputArea
                    label={`Alt Text`}
                    placeholder={'Add alt text'}
                    id={'alt_text'}
                    rows={4}
                    charLimit={125}
                    value={altText}
                    onChange={handleAltTextChange}
                    tooltipArrow={true}
                    tooltip={
                      'This text helps students using screen readers understand what’s in the image and ensures your content is accessible.'
                    }
                  />
                </div>
              </div>
            </div>
            <div className={style.footer}>
              <div className={style.buttonContainer}>
                <ButtonMediumNunito type={'button'} onClick={() => props.onClose(false)}>
                  Cancel
                </ButtonMediumNunito>
                <AccentButtonMediumNunito type="button" onClick={handleSave} disabled={isLoading}>
                  {isLoading ? <AccentButtonSpinner displayText="Saving ..." /> : 'Save'}
                </AccentButtonMediumNunito>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </ThemeProvider>
  );
};

export default enhance(ImageDescModal);
